<!--自然研学馆-->
<template>
    <div class="guide-nav-content" >
        <div class="guide-ext-container" v-show="showMode==='homePage'" v-loading="loading">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">恒岳•自然研学馆</div>
                    <div class="l-b-museum-title-container">线上预热 线下实地探索</div>
                </div>
                <div class="r-museum-title-container">
                    <div v-show="this.isShowBack" class="back-btn-container" @click="backMuseum" >⇦返回</div>
                </div>

            </div>
            <div class="museum-item-container">
                <div class="museum-item-line-container">
                    <div class="museum-item-top-container" v-for="(item,index) in filteredList" :key="index">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">{{item.itemName}}</div>
                                <div class="museum-item-20 mf2">{{item.itemClassify}}</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewHumVideo(item)">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-container" v-if="!loading && filteredList.length===0">
                    <dataEmpty title="暂无资源"/>
                </div>
                <div class="museum-item-bottom-container">
                    <div class="museum-item-bottom-outside">
                        <div class="museum-item-bottom-inside">
                            <div class="museum-item-bottom-inside-l">
                                <div class="museum-item-60 mf1">行•知行合一</div>
                                <div class="museum-item-40 mf2">自然研学实践 户外主题班会 生态体验活动</div>
                            </div>
                            <div class="museum-item-bottom-inside-r dis-align">
                                <div class="inside-r-btn" @click="viewPageEvent()">查看线下活动</div>
                                <div class="inside-r-btn" @click="viewExcursion()">预约专属研学</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--视频子类-->
        <div class="detail-mode" v-show="showMode==='beautyClassify'">
            <beauty-classify :item-id="itemInfo.itemId"
                             :mark-info="innerMarkInfo"
                             @back-model-page="backModelPage"
                             @view-video-list="viewVideoList"/>
        </div>
        <!--子类视频列表-->
        <div class="detail-mode" v-show="showMode==='beautyVideoList'">
            <beauty-video-list :item-id="classifyInfo.itemId"
                               :item-name="classifyInfo.itemClassifyName"
                               :mark-info="innerMarkInfo"
                               @back-model-page="backModelPage"
                               @view-video-info="viewVideoInfo"/>
        </div>
        <!--视频详情-->
        <div class="detail-mode" v-show="showMode==='beautyVideoInfo'">
            <beauty-video-info :video-id="videoInfo.videoId"
                               :mark-info="innerMarkInfo"
                               @back-model-page="backModelPage"/>
        </div>
        <!--研学实践-->
        <div class="detail-mode" v-show="showMode==='museumEventPage'">
            <nature-event-club :museum-id="this.museumId"
                               :mark-info="innerMarkInfo"
                               @back-read-museum="backModelPage"/>
        </div>
        <!--预约专属研学列表-->
        <div class="detail-mode" v-show="showMode==='excursionPage'">
            <excursion-list :mark-info="innerMarkInfo"
                            camp-key="5"
                            @back-page="backModelPage"
                            @view-info="viewExcursionInfo"/>
        </div>
        <!--预约专属研学详情-->
        <div class="detail-mode" v-show="showMode==='excursionInfo'">
            <excursion-info :excursion-id="excursionId"
                            @back-page="backExcursionPage"/>
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {humItemList} from "@/api/admin/museum";
import dataEmpty from "@/components/dataEmpty.vue";
import beautyClassify from "@/components/newMuseum/bymy/beautyClassify.vue";
import beautyVideoList from "@/components/newMuseum/bymy/beautyVideoList.vue";
import beautyVideoInfo from "@/components/newMuseum/bymy/beautyVideoInfo.vue";
import natureEventClub from "@/components/museumEvent/natureEventClub.vue";
import excursionList from "@/components/newMuseum/excursion/excursionList.vue";
import excursionInfo from "@/components/newMuseum/excursion/excursionInfo.vue";

export default {
    name: "natureStudyMuseum",
    components: {natureEventClub, beautyClassify, beautyVideoList, beautyVideoInfo, dataEmpty, excursionList, excursionInfo},
    data() {
        return {
            showMode:'homePage',
            serviceUrl,
            loading:false,
            museumKey:'5',
            filteredList:[],
            itemInfo:{},
            classifyInfo:{},
            videoInfo:{},
            innerMarkInfo:'',
            museumId:"",
            excursionId:'',
        }
    },
    computed: {},
    props:{
        markInfo:{
            type: String,
            default:null
        },
        isShowBack:{
            type: Boolean,
            default:true
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.showMode = 'homePage';
            this.queryHumItemList();
        },
    },
    created() {
        this.queryHumItemList();
    },
    mounted(){},
    methods: {
        /*查询视频分类*/
        queryHumItemList(){
            this.loading = true;
            humItemList({museumKey:this.museumKey}).then(res => {
                if (res.data.code===1){
                    this.filteredList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /*返回五馆首页*/
        backMuseum(){
            this.$emit('child-back-museum', "page");
        },
        /*查看主题视频子类*/
        viewHumVideo(item){
            this.itemInfo = item;
            this.innerMarkInfo = new Date() + '';
            this.showMode = 'beautyClassify'
        },
        /*查看子类视频列表*/
        viewVideoList(item){
            this.classifyInfo = item;
            this.innerMarkInfo = new Date() + '';
            this.showMode = 'beautyVideoList'
        },
        /*查看视频详情*/
        viewVideoInfo(item){
            this.videoInfo = item;
            this.innerMarkInfo = new Date() + '';
            this.showMode = 'beautyVideoInfo'
        },
        /*自然研学实践*/
        viewPageEvent(){
            this.innerMarkInfo = new Date() + '';
            this.museumId = '5';
            this.showMode = 'museumEventPage';
        },
        /*预约专属研学*/
        viewExcursion(){
            this.innerMarkInfo = new Date() + '';
            this.showMode = 'excursionPage';
        },
        /*查看专属研学详情*/
        viewExcursionInfo(item){
            this.excursionId = item.excursionId;
            this.showMode = 'excursionInfo';
        },
        /*返回专属研学列表*/
        backExcursionPage(){
            this.showMode = 'excursionPage';
        },
        /*子组件返回*/
        backModelPage(val){
            if (val === 'beautyClassify'){
                this.showMode = 'beautyClassify'
            }else if (val === 'beautyVideoList'){
                this.showMode = 'beautyVideoList'
            }else {
                this.showMode = "homePage";
            }
        },
    }
}

</script>

<style scoped>
.guide-nav-content{
    width: 100%;
    height: auto;
}
/* 外层容器：白色圆角卡片，高度固定一屏，参照 zcfgResource */
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}
.l-museum-title-container{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #0d55a4;
    font-size: 18px;
    line-height: 1.4;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    flex-shrink: 0;
    display: flex;
    align-items: center;
}
.back-btn-container{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

.museum-item-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 28px;
    box-sizing: border-box;
}
.museum-item-line-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}
.museum-item-top-container{
    width: calc((100% - 40px) / 3);
    height: 130px;
    display: flex;
    align-items: center;
    justify-items: center;
}
.museum-item-top{
    width: 100%;
    height: 100%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.museum-item-60{
    width: 100%;
    height: 60%;
}
.mf1{
    color: #0d55a4;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.mf2{
    color: #9a9a9a;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}
.empty-container{
    width: 100%;
}

.museum-item-bottom-container{
    flex: 1;
    min-height: 0;
    width: 100%;
}
.museum-item-bottom-outside{
    width: 100%;
    height: 66%;
    border: 3px solid #0d55a4;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.museum-item-bottom-inside{
    width: 99%;
    height: 92%;
    border: 1px solid #e99d42;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    display: flex;
}

.museum-item-bottom-inside-l{
    width: calc(100% - 260px);
    height: 100%;
}
.museum-item-bottom-inside-r{
    width: 260px;
    height: 100%;
    gap: 10px;
}
.inside-r-btn{
    flex: 1;
    min-width: 0;
    height: 38%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}

.detail-mode{
    width: 100%;
    height: auto;
}
</style>
